import React from 'react'
import { Button, Input } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

class TimeTrackingEditEntry extends React.Component {

    render = () => {
        this.props.info('TimeTrackingEditEntry.js/render');
        return (<>
            <tr>
                <td className="px-1 pb-1">
                    <Input
                        type={this.props.daily ? "date" : "date"}
                        name={"date"}
                        value={this.props.isFieldNull(this.props.editTaskTimeTracking.date)}
                        onChange={(e) => this.props.onChange(e, 'edit')}
                    />
                </td>
                <td className="px-1 pb-1">
                    <Input
                        type="time"
                        name={"beginTimestamp"}
                        value={this.props.isFieldNull(this.props.editTaskTimeTracking.beginTimestamp)}
                        disabled={this.props.editTaskTimeTracking.userSetDuration}
                        onChange={(e) => this.props.onChange(e, 'edit')}
                    />
                </td>
                <td className="px-1 pb-1">
                    <Input
                        type="time"
                        name={"endTimestamp"}
                        value={this.props.isFieldNull(this.props.editTaskTimeTracking.endTimestamp)}
                        disabled={this.props.editTaskTimeTracking.userSetDuration}
                        onChange={(e) => this.props.onChange(e, 'edit')}
                    />
                </td>
                <td className="px-1 pb-1">
                    <Input
                        type="number"
                        name={"duration"}
                        value={this.props.isFieldNull(this.props.editTaskTimeTracking.duration)}
                        disabled={this.props.editTaskTimeTracking.userPreventSetDuration}
                        onChange={(e) => this.props.onChange(e, 'edit')}
                    />
                </td>
                <td className="px-1 pb-1">
                    <Button
                        color="success"
                        title="Mark as Complete"
                        onClick={() => this.props.onHandleEdit(this.props.id)}
                        disabled={this.props.editTaskTimeTracking.date === '' || ((this.props.editTaskTimeTracking.duration === '' || this.props.editTaskTimeTracking.duration <= 0) && this.props.requireHours)}
                    >
                        <FontAwesomeIcon icon={faCheck} />
                    </Button>
                    <Button color="secondary"
                        title="Cancel"
                        onClick={() => this.props.cb({ editTaskTimeTrackingId: 0, editTaskTimeTracking: { ...this.props.blankTaskTimeTracking } })}>
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </td>
            </tr>
            <tr>
                <td className="border-top-0 pt-0 px-1">
                    <Input
                        type="select"
                        name="employeeId"
                        value={this.props.isFieldNull(this.props.editTaskTimeTracking.employeeId)}
                        onChange={(e) => this.props.onChange(e, 'edit')}>
                        <option value={0}>Select Employee</option>
                        {this.props.employees.filter(employee => employee.active).sort((a,b) => a.lastName.localeCompare(b.lastName)).map(employee => (
                            <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.lastName}, {employee.firstName} </option>
                        ))}
                    </Input>
                    <label className='pl-3 mt-3'><Input 
                        type="checkbox"
                        name="isComplete"
                        checked={this.props.isFieldNull(this.props.editTaskTimeTracking.isComplete)}
                        onChange={(e) => this.props.onChange(e, 'edit')}
                    /> Completed</label>
                </td>
                <td colSpan={3} className="border-top-0 pt-0 px-1">
                    <Input
                        type="textarea"
                        placeholder="Notes"
                        rows={4}
                        name={"notes"}
                        value={this.props.isFieldNull(this.props.editTaskTimeTracking.notes)}
                        onChange={(e) => this.props.onChange(e, 'edit')}
                    />

                </td>
                <td className="border-top-0 pt-0 px-1"></td>
            </tr>
        </>
        )
    }
}

export default TimeTrackingEditEntry;